var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8183 2.68252C17.8765 2.74058 17.9227 2.80955 17.9542 2.88548C17.9857 2.96141 18.0019 3.04281 18.0019 3.12502C18.0019 3.20723 17.9857 3.28863 17.9542 3.36456C17.9227 3.44049 17.8765 3.50946 17.8183 3.56752L4.06829 17.3175C3.95093 17.4349 3.79176 17.5008 3.62579 17.5008C3.45982 17.5008 3.30065 17.4349 3.18329 17.3175C3.06593 17.2002 3 17.041 3 16.875C3 16.709 3.06593 16.5499 3.18329 16.4325L16.9333 2.68252C16.9913 2.62431 17.0603 2.57814 17.1362 2.54663C17.2122 2.51512 17.2936 2.4989 17.3758 2.4989C17.458 2.4989 17.5394 2.51512 17.6153 2.54663C17.6913 2.57814 17.7602 2.62431 17.8183 2.68252Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18166 2.68252C3.12346 2.74058 3.07728 2.80955 3.04577 2.88548C3.01427 2.96141 2.99805 3.04281 2.99805 3.12502C2.99805 3.20723 3.01427 3.28863 3.04577 3.36456C3.07728 3.44049 3.12346 3.50946 3.18166 3.56752L16.9317 17.3175C17.049 17.4349 17.2082 17.5008 17.3742 17.5008C17.5401 17.5008 17.6993 17.4349 17.8167 17.3175C17.934 17.2002 18 17.041 18 16.875C18 16.709 17.934 16.5499 17.8167 16.4325L4.06666 2.68252C4.00861 2.62431 3.93964 2.57814 3.86371 2.54663C3.78777 2.51512 3.70637 2.4989 3.62416 2.4989C3.54196 2.4989 3.46055 2.51512 3.38462 2.54663C3.30869 2.57814 3.23972 2.62431 3.18166 2.68252Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.fddb5840639e12553a267dc3889c4d28.svg";
export { ForwardRef as ReactComponent };